var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.613,
    height: 122.945,
    viewBox: "0 0 91.613 122.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131",
    transform: "translate(19807 22003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M83.978,99.327H73.8a27.993,27.993,0,1,0-55.985,0H7.634A7.627,7.627,0,0,1,0,91.694V72.547A3.738,3.738,0,0,1,1.328,69.69a69.892,69.892,0,0,1,10.163-7.1,68.988,68.988,0,0,1,68.623,0,69.892,69.892,0,0,1,10.163,7.1,3.1,3.1,0,0,1,.986,1.467,9.291,9.291,0,0,1,.35,2.888v17.65a7.628,7.628,0,0,1-7.634,7.633ZM45.806,45.843A22.784,22.784,0,0,1,33,41.929a22.986,22.986,0,0,1-8.3-10.085,22.906,22.906,0,0,1,2.112-21.738A22.972,22.972,0,0,1,36.891,1.8a22.859,22.859,0,0,1,21.72,2.113A22.986,22.986,0,0,1,66.91,14,22.905,22.905,0,0,1,64.8,35.737a22.973,22.973,0,0,1-10.077,8.3A22.744,22.744,0,0,1,45.806,45.843Z",
    transform: "translate(-19807 -22003)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_4_",
    "data-name": "user (4)",
    transform: "translate(-19783.855 -22003)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 22.903,
    cy: 22.903,
    r: 22.903,
    transform: "translate(0)",
    fill: "#2196f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(-19784.096 -21925.861)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 22.903,
    cy: 22.903,
    r: 22.903,
    transform: "translate(0 0)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    transform: "translate(12.493 12.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M221.406,388.164H204.749a2.082,2.082,0,1,1,0-4.164h16.657a2.082,2.082,0,1,1,0,4.164Z",
    transform: "translate(-202.667 -375.672)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M247.416,362.154a2.082,2.082,0,0,1-2.082-2.082V343.415a2.082,2.082,0,1,1,4.164,0v16.657A2.082,2.082,0,0,1,247.416,362.154Z",
    transform: "translate(-237.006 -341.333)",
    fill: "#fafafa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIcon);
export default __webpack_public_path__ + "static/media/register-icon.16309388e38c23bff2789c3fae5259db.svg";
export { ForwardRef as ReactComponent };